import React from 'react';
import { KitPurchaseCard } from './KitPurchaseCard';
export function PortalOffer() {
  return <section className="w-full overflow-hidden bg-[#fdfbf7] px-4 py-10 md:py-14" data-id="element-259" data-mp="26xalgpqsac3u">
      <KitPurchaseCard data-id="element-260" data-mp="21yh42m8dm0ye" />
    </section>;
}